/**
 * Spinner Atom
 *
 * Loading spinner
 */
import React from 'react'
import { Loader2 } from 'lucide-react'

const sizes = {
	sm: 'w-4 h-4',
	md: 'w-6 h-6',
	lg: 'w-8 h-8',
	xl: 'w-12 h-12',
}

export default function Spinner({ size = 'md', className = '' }) {
	return (
		<Loader2 className={`animate-spin text-primary ${sizes[size]} ${className}`} />
	)
}

export function LoadingScreen({ message = 'Carregando...' }) {
	return (
		<div className="flex flex-col items-center justify-center min-h-[400px]">
			<Spinner size="xl" />
			<p className="mt-4 text-text-body">{message}</p>
		</div>
	)
}
